import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Profile from "assets/img/default-avatar.png"
import "assets/css/demo.css"
import Box from '@mui/material/Box';
import {BsArrowLeftShort} from "react-icons/bs"
import MyContext from "MyContext";
import PaginationSection from './PaginationSection';

import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";

import ReactPaginate from 'react-paginate';
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form
} from "react-bootstrap";
import Switch from 'react-switch'; // Import the react-switch component




function Employer() {
  const { endPointUrl, Token } = useContext(MyContext);
  const [ID, setID] = useState([])
  const [allDetails, setallDetails] = useState([]);
  const [employer, setemployer] = useState([]);
  const history = useHistory();

  const handleStatusToggle = async (employerId, newStatusValue) => {
    console.log("Toggle called for freelancer ID:", employerId);
    try {
      await axios.post(endPointUrl + "/updateuserProfile", {
        Token,
        id: employerId,
        Status_by_Admin: newStatusValue,
      });
  
      setallDetails((prevDetails) =>
        prevDetails.map((employer) =>
        employer.id === employerId
            ? { ...employer, Status_by_Admin: newStatusValue }
            : employer
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const getEmployers = async () => {
    try {
      const { data } = await axios.post(endPointUrl + "/admin/featuredemployers", {
        Token,
      });

      setallDetails(data.data);
      // console.log(allDetails);

    } catch {
      console.log("get Employer details is not working");
    }
  };
  const data = React.useMemo(() => allDetails, [allDetails]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No.",
        accessor: (row, index) => index + 1, // Auto-incremented serial number
      },
      {
        Header: ' ',
        Cell: tableProps => (
          <div><img
            src={tableProps.row.original.Photo === "" || tableProps.row.original.Photo == null
              ? Profile
              : `${endPointUrl}/images/${tableProps.row.original.Photo}`}
            // src={`${endPointUrl}/images/${tableProps.row.original.Photo}`}
            width={40}
            height={40}
            style={{ borderRadius: "50%" }}
          /></div>
        )
      },
      {
        Header: "Name",
        accessor: "Name",
      },
      {
        Header: "Email",
        accessor: "Email",
      },
      {
        Header: "City",
        accessor: "City",
      },
      {
        Header: "Contact No.",
        accessor: "Mobile",
      },
      {
        Header: "Active",
        accessor:"Status_by_Admin",
        Cell: ({ row }) => (
          <Switch
            onChange={(checked) => handleStatusToggle(row.original.id, checked)}
            checked={row.original.Status_by_Admin}
            onColor="#86d3ff"
            onHandleColor="#07b274"
            handleDiameter={20}
            uncheckedIcon={false}
            checkedIcon={false}
            boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          />
        ),
      },
      {
        Header: "Action",
        accessor: "id",
        Cell: ({ row }) => (
          <div>
            <span
             onClick={() => handleclick(row.original.id)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            >
              <Button style={{fill:"#07b274"}}>Show More</Button>
            </span>
          </div>
        ),
      },
    ],
    []
  );
  useEffect(() => {
    getEmployers();
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    gotoPage,
    pageCount,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
      autoResetPage: false,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;
  const EmployerSelect = (Id) => {
    setID(Id);
    let select = allDetails.filter((item) => {
      // console.log(cell);
      return (item.id === Id);
    })
    setemployer(select);
    console.log(employer)
  };

  const handleclick = (Id) => {
    console.log(Id);
    history.push(`/admin/Employer-Details/${Id}`); 
  
    
  };;

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  <Form className="d-flex">
                    <Form.Control
                      type="search"
                      placeholder="Search"
                      className="mx-2"
                      aria-label="Search"
                      value={globalFilter || ''} onChange={(e) => setGlobalFilter(e.target.value)}
                    />
                  </Form>

                </Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped " {...getTableProps()}>
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render("Header")}
                            {/* Add a sort direction indicator */}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr  {...row.getRowProps()}>
                          {/* {console.log(row.original.id)} */}
                          {row.cells.map((cell) => {
                            //  const { column } = cell.value;
                            //  let Id = column.Name;
                            //  console.log(cell.value);

                            return (<td  {...cell.getCellProps()}> {cell.render("Cell")}</td>)

                          })}

                        </tr>
                      );
                    }

                    )}
                  </tbody>
                </Table>
              </Card.Body>
              <PaginationSection
      pageIndex={pageIndex}
      pageCount={pageOptions.length}
      canPreviousPage={canPreviousPage}
      canNextPage={canNextPage}
      gotoPage={gotoPage}
      previousPage={previousPage}
      nextPage={nextPage}
      pageSize={pageSize}
      setPageSize={setPageSize}
      pageOptions={pageOptions}
    />

            </Card>

          </Col>
        </Row>
      </Container>
    
    </>
  );
}

export default Employer;